export default "__VITE_ASSET__lDsogBnL__"